module.exports = __webpack_public_path__ + "static/media/linkedin-filled.fc7bef5c.svg";